import { PlatformComponentProps } from "@b2bportal/core-types";
import { useScrolltopOnPathChange } from "@b2bportal/core-utilities";
import clsx from "clsx";
import "./App.scss";

export const AirPriceWatchApp = ({
  children,
  className,
}: PlatformComponentProps) => {
  useScrolltopOnPathChange();

  return (
    <div className={clsx("core-air-price-watch-app", className)}>
      {children}
    </div>
  );
};

export default AirPriceWatchApp;
